import type { ReactNode } from 'react';

/** Outline icons on a 24 px grid, 1.8 px stroke (currentColor). Decorative: the control carries the label. */
const PATHS = {
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2.5" />
      <path d="m3.5 7 8.5 6 8.5-6" />
    </>
  ),
  moon: <path d="M20 14.6A8 8 0 1 1 9.4 4a6.4 6.4 0 0 0 10.6 10.6z" />,
  power: (
    <>
      <path d="M12 3.5v8" />
      <path d="M6.6 6.9a7.6 7.6 0 1 0 10.8 0" />
    </>
  ),
  drop: <path d="M12 3.2s6 6.5 6 10.8a6 6 0 0 1-12 0c0-4.3 6-10.8 6-10.8z" />,
  timer: (
    <>
      <circle cx="12" cy="13.5" r="7.5" />
      <path d="M12 10v3.7l2.4 1.6M9.6 3h4.8" />
    </>
  ),
  weight: (
    <>
      <path d="M6.4 9.5h11.2l2 10.5H4.4z" />
      <path d="M9.3 9.5a2.7 2.7 0 1 1 5.4 0" />
    </>
  ),
  thermo: (
    <>
      <path d="M14 14.6V5.2a2 2 0 0 0-4 0v9.4a4 4 0 1 0 4 0z" />
      <path d="M12 9v7" />
    </>
  ),
  qr: (
    <>
      <rect x="3.5" y="3.5" width="6.5" height="6.5" rx="1.2" />
      <rect x="14" y="3.5" width="6.5" height="6.5" rx="1.2" />
      <rect x="3.5" y="14" width="6.5" height="6.5" rx="1.2" />
      <path d="M14 14h2.6v2.6H14zM20.5 14v.1M14 20.5h.1M17.5 20.5h3v-3" />
    </>
  ),
  scan: (
    <>
      <path d="M3.5 8V6A2.5 2.5 0 0 1 6 3.5h2M16 3.5h2A2.5 2.5 0 0 1 20.5 6v2M20.5 16v2a2.5 2.5 0 0 1-2.5 2.5h-2M8 20.5H6A2.5 2.5 0 0 1 3.5 18v-2" />
      <path d="M7.5 12h9" />
    </>
  ),
  check: <path d="m5 12.5 4.5 4.5L19 7.5" />,
  chevronRight: <path d="m9.5 6 6 6-6 6" />,
  chevronLeft: <path d="m14.5 6-6 6 6 6" />,
  chevronDown: <path d="m6 9.5 6 6 6-6" />,
  plus: <path d="M12 5v14M5 12h14" />,
  minus: <path d="M5 12h14" />,
  close: <path d="M6.5 6.5l11 11M17.5 6.5l-11 11" />,
  bean: (
    <>
      <ellipse cx="12" cy="12" rx="5.6" ry="8.4" transform="rotate(35 12 12)" />
      <path d="M8.6 17.4c2.6-2 3.4-7.6 6.8-10.8" />
    </>
  ),
  machine: (
    <>
      <rect x="4.5" y="3.5" width="15" height="11" rx="2.2" />
      <circle cx="12" cy="9" r="2.7" />
      <path d="M8.5 14.5v2h7v-2M6 20.5h12M10 17.5v1.2" />
    </>
  ),
  cup: (
    <>
      <path d="M4.5 9h12v4.5a5 5 0 0 1-5 5h-2a5 5 0 0 1-5-5z" />
      <path d="M16.5 10.5h1.2a2.4 2.4 0 0 1 0 4.8h-1.5M8 3.5v2.5M12 3.5v2.5" />
    </>
  ),
  sliders: (
    <>
      <path d="M4 7h9M17 7h3M4 17h3M11 17h9" />
      <circle cx="15" cy="7" r="2" />
      <circle cx="9" cy="17" r="2" />
    </>
  ),
  wrench: (
    <path d="M14.7 6.3a4.2 4.2 0 0 0-5.6 5.3L3.8 16.9a1.6 1.6 0 0 0 2.3 2.3l5.3-5.3a4.2 4.2 0 0 0 5.3-5.6l-2.6 2.6-2.2-.4-.4-2.2z" />
  ),
  key: (
    <>
      <circle cx="8" cy="15" r="4.2" />
      <path d="m11 12 8.5-8.5M16.5 6.5l2.5 2.5M14 9l2 2" />
    </>
  ),
  arrowRight: <path d="M5 12h14M13 6l6 6-6 6" />,
  cloudOff: (
    <path d="M7 18.5a4.5 4.5 0 0 1-1.4-8.8M9.2 6.3A6 6 0 0 1 17.8 9a4 4 0 0 1 2.4 7.3M3.5 3.5l17 17" />
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M3.5 12h17M12 3.5c2.4 2.4 3.4 5.2 3.4 8.5s-1 6.1-3.4 8.5c-2.4-2.4-3.4-5.2-3.4-8.5s1-6.1 3.4-8.5z" />
    </>
  ),
  logout: (
    <>
      <path d="M14 4.5h3.5a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H14" />
      <path d="M10 8l-4 4 4 4M6 12h9" />
    </>
  ),
  alert: (
    <>
      <path d="M12 4 2.8 19.5h18.4z" />
      <path d="M12 10v4.2M12 17v.1" />
    </>
  ),
  /** the app's reading of a series (a note under figures) */
  pulse: <path d="M3 12h4l3-7 4 14 3-7h4" />,
  link: (
    <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />
  ),
  /** unpairing a machine: a broken chain */
  unlink: (
    <path d="M18.8 12.3l1.7-1.7a5 5 0 0 0-7.1-7.1l-1.7 1.7M5.2 11.7l-1.7 1.7a5 5 0 0 0 7.1 7.1l1.7-1.7M8 2v3M2 8h3M16 22v-3M22 16h-3" />
  ),
  /** the drip tray (prototype "Maschine: bereit") */
  tray: <path d="M4 6h16l-1.5 9a2 2 0 0 1-2 1.7h-9a2 2 0 0 1-2-1.7zM8 6V3M12 6V1.5M16 6V3" />,
  /** the icons of the prototype's rows (Zeitplan, Kurve, the pages of Einstellungen, Konto, Rezept) */
  clock: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  curve: <path d="M4 19V5M4 19h16M7 15l4-5 3 3 5-6" />,
  scale: <path d="M4 14h16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zM8 14v-3h8v3" />,
  tank: <path d="M7 4h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM6 13h12" />,
  display: <path d="M20 12a8 8 0 1 1-16 0a8 8 0 1 1 16 0M15 12a3 3 0 1 1-6 0a3 3 0 1 1 6 0" />,
  sparkle: <path d="M12 4l1.8 4.6L18.5 10l-4.7 1.6L12 16l-1.8-4.4L5.5 10l4.7-1.4z" />,
  /** looking something up (board "Eine Bohne": "Bohne nachschlagen") */
  search: <path d="M16 16l4 4M18 11a7 7 0 1 1-14 0a7 7 0 1 1 14 0" />,
  /** a card's own actions ("Mehr", the Claude card) */
  more: <path className="icon-dots" d="M6 12h.01M12 12h.01M18 12h.01" />,
  dial: <path d="M5 17a8 8 0 1 1 14 0M12 13l4-4" />,
  info: <path d="M20.5 12a8.5 8.5 0 1 1-17 0a8.5 8.5 0 1 1 17 0M12 11v5M12 8h.01" />,
  passkey: <path d="M15.5 8.5a3.5 3.5 0 1 1-7 0a3.5 3.5 0 1 1 7 0M12 12v8M12 16.5h3M12 19.5h2" />,
  stopAt: <path d="M12 3v14M7 12l5 5 5-5M5 21h14" />,
  grip: <path className="icon-dots" d="M9 6h.01M15 6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01" />,
  calendar: (
    <>
      <rect x="4" y="5" width="16" height="15" rx="2.5" />
      <path d="M4 10h16M8.5 3v4M15.5 3v4" />
    </>
  ),
  play: <path className="icon-fill" d="M8 5.5v13l10.5-6.5z" />,
  // board "Gerät": restarting the machine, downloading the export
  restart: (
    <>
      <path d="M19.5 12a7.5 7.5 0 1 1-2.2-5.3" />
      <path d="M19.5 4.5v4h-4" />
    </>
  ),
  download: (
    <>
      <path d="M12 4v11" />
      <path d="m7.5 10.5 4.5 4.5 4.5-4.5" />
      <path d="M5 19.5h14" />
    </>
  ),
} satisfies Record<string, ReactNode>;

export type IconName = keyof typeof PATHS;

export function Icon({
  name,
  size = 'md',
  className,
}: {
  name: IconName;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}) {
  return (
    <svg
      className={className ? `icon icon-${size} ${className}` : `icon icon-${size}`}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      {PATHS[name]}
    </svg>
  );
}

/** Google "G" for the sign-in button, in its brand colours (Google sign-in branding guidelines). */
export function GoogleLogo() {
  return (
    <svg className="icon icon-md google-logo" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      <path
        fill="#FFC107"
        d="M43.6 20.1H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 8 3l5.7-5.7C34 6.1 29.3 4 24 4 13 4 4 13 4 24s9 20 20 20 20-9 20-20c0-1.3-.1-2.6-.4-3.9z"
      />
      <path
        fill="#FF3D00"
        d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 8 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"
      />
      <path
        fill="#4CAF50"
        d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.5-4.5 2.4-7.2 2.4-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"
      />
      <path
        fill="#1976D2"
        d="M43.6 20.1H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.6-.4-3.9z"
      />
    </svg>
  );
}
